// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdminLoginForm-space1-uS0vZ {
	margin-bottom: 6px !important;
}

.AdminLoginForm-space2-C0XyK {
	margin-bottom: 12px !important;
}

.AdminLoginForm-space3-Vd7he {
	margin-bottom: 18px !important;
}

.AdminLoginForm-space4-R8RQA {
	margin-bottom: 24px !important;
}

.AdminLoginForm-space5-BsE7g {
	margin-bottom: 30px !important;
}

.AdminLoginForm-space6-UVaRx {
	margin-bottom: 36px !important;
}

.AdminLoginForm-space7-RFXLY {
	margin-bottom: 42px !important;
}

.AdminLoginForm-space8-nkWxi {
	margin-bottom: 48px !important;
}

.AdminLoginForm-spaceTop1-YGy0m {
	margin-top: 6px !important;
}

.AdminLoginForm-spaceTop2-N6jz1 {
	margin-top: 12px !important;
}

.AdminLoginForm-spaceTop3-Mory8 {
	margin-top: 18px !important;
}

.AdminLoginForm-spaceTop4-JDKRc {
	margin-top: 24px !important;
}

.AdminLoginForm-spaceTop5-n2IoF {
	margin-top: 30px !important;
}

.AdminLoginForm-spaceTop6-jTOxF {
	margin-top: 36px !important;
}

.AdminLoginForm-spaceTop7-LL78l {
	margin-top: 42px !important;
}

.AdminLoginForm-spaceTop8-L6vih {
	margin-top: 48px !important;
}

.AdminLoginForm-noMargin-i_8Re {
	margin: 0px !important;
}

.AdminLoginForm-padding1-Elvxu {
	padding-bottom: 6px !important;
}

.AdminLoginForm-padding2-Cvntx {
	padding-bottom: 12px !important;
}

.AdminLoginForm-padding3-D1Ue1 {
	padding-bottom: 18px !important;
}

.AdminLoginForm-padding4-eKsOE {
	padding-bottom: 24px !important;
}

.AdminLoginForm-padding5-qjgyj {
	padding-bottom: 30px !important;
}

.AdminLoginForm-padding6-WCOah {
	padding-bottom: 36px !important;
}

.AdminLoginForm-padding7-LdHzO {
	padding-bottom: 42px !important;
}

.AdminLoginForm-paddingTop1-TbZGM {
	padding-top: 6px !important;
}

.AdminLoginForm-paddingTop2-L_zmL {
	padding-top: 12px !important;
}

.AdminLoginForm-paddingTop3-uGGks {
	padding-top: 18px !important;
}

.AdminLoginForm-paddingTop4-u1ujn {
	padding-top: 24px !important;
}

.AdminLoginForm-paddingTop5-B4ku8 {
	padding-top: 30px !important;
}

.AdminLoginForm-paddingTop6-JAzzV {
	padding-top: 36px !important;
}

.AdminLoginForm-paddingTop7-u17kr {
	padding-top: 42px !important;
}

.AdminLoginForm-noPadding-vwPF0 {
	padding: 0px !important;
}

.AdminLoginForm-spaceMarginBottom0-PvFBD {
	margin-bottom: 0;
}

.AdminLoginForm-textBold-gylX9 {
	font-weight: 500 !important;
}

.AdminLoginForm-textBolder-p2lyt {
	font-weight: 700 !important;
}

.AdminLoginForm-textNormal-dyYo3 {
	font-weight: normal !important;
}

/*New Design Text Colors */

.AdminLoginForm-textDarkBlue-w_yWE {
	color: rgb(20, 39, 94) !important;
}

.AdminLoginForm-textLightBlue-I4mJt {
	color: rgb(57, 87, 106) !important;
}

.AdminLoginForm-textLightSandleGreen-ksOIB {
	color: rgb(76, 86, 41) !important;
}

.AdminLoginForm-textLightBrown-a8ufN {
	color: rgb(115, 79, 33) !important;
}

.AdminLoginForm-textMediumMaroon-Nq12N {
	color: rgb(87, 37, 51) !important;
}

.AdminLoginForm-textBrown-HnTOj {
	color: rgb(160, 47, 24) !important;
}

.AdminLoginForm-textMaroon-Zy5ai {
	color: rgb(155, 49, 67) !important;
}

.AdminLoginForm-textDarkBrown-PKPB1 {
	color: rgb(83, 18, 16) !important;
}

.AdminLoginForm-textMediumBrown-S0ZmG {
	color: rgb(142, 28, 10) !important;
}

.AdminLoginForm-textSkyBlue-wu94v {
	color: rgb(37, 117, 141) !important;
}

.AdminLoginForm-textGray-ZkAwj {
	color: rgb(77, 65, 51) !important;
}

.AdminLoginForm-errorMessage-w3bhr {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

/** Admin - Common - Start **/

.AdminLoginForm-userText-JGPPb {
	padding-top: 3px;
	color: var(--common-text-color);
	margin: 0px;
	font-size: 14px;
}

.AdminLoginForm-panelHeader-LCVWK {
	border-radius: 4px;
	padding: 20px 25px;
	border: 1px solid var(--primary-border);
}

.AdminLoginForm-exportSection-P5dwC {
	background: var(--common-gray-bg-color);
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
}

.AdminLoginForm-exportSectionGridSub-z7Lf0 {
	grid-template-columns: 50% 49% !important;
}

.AdminLoginForm-exportText-zMDXf {
	color: var(--common-text-color) !important;
	text-decoration: none !important;
	display: inline-block;
	float: right;
}

.AdminLoginForm-exportLinkImg-Eh2R4 {
	background: var(--primary-white-bg);
	padding: 10px;
	margin-left: 12px;
	border-radius: 4px;
}

.AdminLoginForm-exportImg-NO3_N {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.AdminLoginForm-linkBtn-B7UsF {
	line-height: 24px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 15px;
	text-align: center;
}

.AdminLoginForm-table-dpwsJ {
	display: table;
}

.AdminLoginForm-tableRow-jYccS {
	display: table-row;
}

.AdminLoginForm-tableCell-JB3Y0 {
	display: table-cell;
	float: none;
}

.AdminLoginForm-formGroup-zV1G5 {
	margin-bottom: 6px;
}

.AdminLoginForm-marginTop0-B0oSL {
	margin-top: 0;
}

.AdminLoginForm-marginBottom20-BmJLW {
	margin-bottom: 20px;
}

/******************* Admin Banner Image Section Start ****************/

.AdminLoginForm-bannerImageBg-Y2ZS3 {
	width: 100%;
	height: 100%;
	min-height: 179px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	position: relative;
	border-radius: 0px;
}

.AdminLoginForm-bannerDelete-bPGpT {
	position: absolute;
	top: 5px;
	right: 20px;
}

/*******************Admin Modal Start **********************/

a,
a:hover {
	cursor: pointer;
}

.AdminLoginForm-exportLink-pLWrL {
	padding-top: 10px;
	padding-right: 10px;
}

.AdminLoginForm-seachContent-Hxuvm {
	padding-left: 0px;
	margin-bottom: 5px;
}

.AdminLoginForm-marginBottom9-XLx8v {
	margin-bottom: 9px;
}

.AdminLoginForm-spaceTop52-lFpMo {
	margin-top: 52px;
}

.AdminLoginForm-profileViewInner-GuLXP {
	padding: 10px;
	border-top: 1px solid var(--primary-border);
	word-break: break-all;
}

.AdminLoginForm-profileViewMain-yIRiz {
	border: 1px solid var(--primary-border);
	border-radius: 0px;
	border-top: 0;
}

.AdminLoginForm-profileViewlabel-lGl8E {
	display: inline-block;
	width: 38%;
	vertical-align: middle;
}

.AdminLoginForm-profileViewMainContent-YjYPL {
	display: inline-block;
	width: 62%;
	vertical-align: middle;
}

.AdminLoginForm-reviewsFormStar-pgKst {
	font-size: 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 2px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.AdminLoginForm-reviewsFormStar-pgKst svg {
	cursor: pointer;
}

.AdminLoginForm-addLanguageText-RTkE6 {
	font-size: 16px;
}

/***************** Export Section Start *********************/

@media screen and (max-width: 991px) {
	.AdminLoginForm-exportSection-P5dwC {
		grid-template-columns: 100%;
	}

	.AdminLoginForm-spaceTop52-lFpMo {
		margin-top: 18px;
	}

	.AdminLoginForm-exportText-zMDXf {
		float: none;
		margin-top: 12px;
	}

	.AdminLoginForm-exportSectionGridSub-z7Lf0 {
		grid-template-columns: 100% !important;
	}
}

/***************** Export Section End *********************/

/*******************Admin Modal Start **********************/

/*******************Admin Modal End **********************/

/*********************** Profile View Section  Start***********************/

@media screen and (max-width: 767px) {
	.AdminLoginForm-profileViewlabel-lGl8E {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.AdminLoginForm-profileViewMainContent-YjYPL {
		width: 100%;
		text-align: center;
	}

	.AdminLoginForm-panelHeader-LCVWK {
		padding: 15px 15px;
	}

}

/*********************** Profile View Section  Start***********************/

.AdminLoginForm-loginMainBg-yMjYH {
  display: grid;
  grid-template-columns: 50% 50%;
  height: 100vh;
}

.AdminLoginForm-formInner-K8Qah {
  width: 100%;
  max-width: 432px;
  margin: 0 auto;
  padding: 0px 15px;
}

.AdminLoginForm-loginBg-AcqCe {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 50%;
  border-radius: 15px;
}

.AdminLoginForm-loginbtn-Mx3Ej {
  padding: 12px 21px !important;
}

.AdminLoginForm-loginTitle-ufieP {
  font-size: 40px;
  font-weight: 600;
  color: var(--common-text-color);
  margin: 18px 0 0 0;
}

.AdminLoginForm-loginTitleScetion-sh6M8 {
  text-align: center;
  margin-bottom: 33px;
}

.AdminLoginForm-loginTitleScetion-sh6M8 img {
  width: 100%;
  max-width: 120px;
}

.AdminLoginForm-arrowIconCss-eyxVu {
  padding-left: 6px;
}

.AdminLoginForm-topPadding-D2gDM {
  padding: 26px 30px 64px;
}

.AdminLoginForm-twoPadding-VEOx7 {
  padding: 0 24px;
}

.AdminLoginForm-bgColor-ukpet {
  background-color: var(--common-gray-bg-color);
  padding: 20px;
}

.AdminLoginForm-siteNameCss-JRg0C {
  font-size: 25px;
  font-weight: 500;
}

@media screen and (max-width: 991px) {
  .AdminLoginForm-mobileWrap-qjOrn {
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    -webkit-box-pack: center !important;
        -ms-flex-pack: center !important;
            justify-content: center !important;
    gap: 10px !important;
    justify-content: center !important;
  }
}

@media screen and (max-width: 767px) {
  .AdminLoginForm-loginBg-AcqCe {
    display: none
  }

  .AdminLoginForm-bgColor-ukpet {
    display: none;
  }

  .AdminLoginForm-loginMainBg-yMjYH {
    grid-template-columns: 100%;
  }

  .AdminLoginForm-formInner-K8Qah {
    padding: 0px 15px 50px;
  }
}

@media screen and (max-width: 320px) {
  .AdminLoginForm-mobileWrap-qjOrn {
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    -webkit-box-pack: center !important;
        -ms-flex-pack: center !important;
            justify-content: center !important;
    gap: 10px !important;
    justify-content: center !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/siteadmin/AdminLoginForm/AdminLoginForm.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5LA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACLA,6BAA6B;;AAC7B;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,uCAAuC;CACvC,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,0CAA0C;CAC1C,gCAAgC;CAChC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,mCAAmC;CACnC,aAAa;CACb,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAGA,sEAAsE;;AACtE;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,wBAAwB;CACxB,4BAA4B;CAC5B,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA,4DAA4D;;AAC5D;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,qBAAqB;AACtB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA,6DAA6D;;AAC7D;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,sCAAsC;CACvC;AACD;;AAEA,2DAA2D;;AAC3D,4DAA4D;;AAE5D,0DAA0D;;AAE1D,2EAA2E;;AAG3E;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;AAED;;AAEA,2EAA2E;;ACtN3E;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,sBAAsB;EACtB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAGA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6CAA6C;EAC7C,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,mBAAe;QAAf,eAAe;IACf,mCAAkC;QAAlC,gCAAkC;YAAlC,kCAAkC;IAClC,oBAAoB;IACpB,kCAAkC;EACpC;AACF;;AAEA;EACE;IACE;EACF;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,mBAAe;QAAf,eAAe;IACf,mCAAkC;QAAlC,gCAAkC;YAAlC,kCAAkC;IAClC,oBAAoB;IACpB,kCAAkC;EACpC;AACF","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../helpers.css';\n@import '../utils.css';\n\n/** Admin - Common - Start **/\n.userText {\n\tpadding-top: 3px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px;\n\tfont-size: 14px;\n}\n\n.panelHeader {\n\tborder-radius: 4px;\n\tpadding: 20px 25px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.exportSection {\n\tbackground: var(--common-gray-bg-color);\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n\tborder-top-left-radius: 20px;\n\tborder-top-right-radius: 20px;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--common-text-color) !important;\n\ttext-decoration: none !important;\n\tdisplay: inline-block;\n\tfloat: right;\n}\n\n.exportLinkImg {\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px;\n\tmargin-left: 12px;\n\tborder-radius: 4px;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.linkBtn {\n\tline-height: 24px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 15px;\n\ttext-align: center;\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.marginTop0 {\n\tmargin-top: 0;\n}\n\n.marginBottom20 {\n\tmargin-bottom: 20px;\n}\n\n\n/******************* Admin Banner Image Section Start ****************/\n.bannerImageBg {\n\twidth: 100%;\n\theight: 100%;\n\tmin-height: 179px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: 5px;\n\tright: 20px;\n}\n\n/*******************Admin Modal Start **********************/\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.seachContent {\n\tpadding-left: 0px;\n\tmargin-bottom: 5px;\n}\n\n.marginBottom9 {\n\tmargin-bottom: 9px;\n}\n\n.spaceTop52 {\n\tmargin-top: 52px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-top: 1px solid var(--primary-border);\n\tword-break: break-all;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 0px;\n\tborder-top: 0;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%;\n\tvertical-align: middle;\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n\tvertical-align: middle;\n}\n\n.reviewsFormStar {\n\tfont-size: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 2px;\n\tflex-wrap: wrap;\n}\n\n.reviewsFormStar svg {\n\tcursor: pointer;\n}\n\n.addLanguageText {\n\tfont-size: 16px;\n}\n\n/***************** Export Section Start *********************/\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.spaceTop52 {\n\t\tmargin-top: 18px;\n\t}\n\n\t.exportText {\n\t\tfloat: none;\n\t\tmargin-top: 12px;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n}\n\n/***************** Export Section End *********************/\n/*******************Admin Modal Start **********************/\n\n/*******************Admin Modal End **********************/\n\n/*********************** Profile View Section  Start***********************/\n\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 15px 15px;\n\t}\n\n}\n\n/*********************** Profile View Section  Start***********************/","@import '../admin-common.css';\n\n.loginMainBg {\n  display: grid;\n  grid-template-columns: 50% 50%;\n  height: 100vh;\n}\n\n.formInner {\n  width: 100%;\n  max-width: 432px;\n  margin: 0 auto;\n  padding: 0px 15px;\n}\n\n.loginBg {\n  width: 100%;\n  height: 100%;\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: 50% 50%;\n  border-radius: 15px;\n}\n\n.loginbtn {\n  padding: 12px 21px !important;\n}\n\n\n.loginTitle {\n  font-size: 40px;\n  font-weight: 600;\n  color: var(--common-text-color);\n  margin: 18px 0 0 0;\n}\n\n.loginTitleScetion {\n  text-align: center;\n  margin-bottom: 33px;\n}\n\n.loginTitleScetion img {\n  width: 100%;\n  max-width: 120px;\n}\n\n.arrowIconCss {\n  padding-left: 6px;\n}\n\n.topPadding {\n  padding: 26px 30px 64px;\n}\n\n.twoPadding {\n  padding: 0 24px;\n}\n\n.bgColor {\n  background-color: var(--common-gray-bg-color);\n  padding: 20px;\n}\n\n.siteNameCss {\n  font-size: 25px;\n  font-weight: 500;\n}\n\n@media screen and (max-width: 991px) {\n  .mobileWrap {\n    flex-wrap: wrap;\n    justify-content: center !important;\n    gap: 10px !important;\n    justify-content: center !important;\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .loginBg {\n    display: none\n  }\n\n  .bgColor {\n    display: none;\n  }\n\n  .loginMainBg {\n    grid-template-columns: 100%;\n  }\n\n  .formInner {\n    padding: 0px 15px 50px;\n  }\n}\n\n@media screen and (max-width: 320px) {\n  .mobileWrap {\n    flex-wrap: wrap;\n    justify-content: center !important;\n    gap: 10px !important;\n    justify-content: center !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `AdminLoginForm-space1-uS0vZ`,
	"space2": `AdminLoginForm-space2-C0XyK`,
	"space3": `AdminLoginForm-space3-Vd7he`,
	"space4": `AdminLoginForm-space4-R8RQA`,
	"space5": `AdminLoginForm-space5-BsE7g`,
	"space6": `AdminLoginForm-space6-UVaRx`,
	"space7": `AdminLoginForm-space7-RFXLY`,
	"space8": `AdminLoginForm-space8-nkWxi`,
	"spaceTop1": `AdminLoginForm-spaceTop1-YGy0m`,
	"spaceTop2": `AdminLoginForm-spaceTop2-N6jz1`,
	"spaceTop3": `AdminLoginForm-spaceTop3-Mory8`,
	"spaceTop4": `AdminLoginForm-spaceTop4-JDKRc`,
	"spaceTop5": `AdminLoginForm-spaceTop5-n2IoF`,
	"spaceTop6": `AdminLoginForm-spaceTop6-jTOxF`,
	"spaceTop7": `AdminLoginForm-spaceTop7-LL78l`,
	"spaceTop8": `AdminLoginForm-spaceTop8-L6vih`,
	"noMargin": `AdminLoginForm-noMargin-i_8Re`,
	"padding1": `AdminLoginForm-padding1-Elvxu`,
	"padding2": `AdminLoginForm-padding2-Cvntx`,
	"padding3": `AdminLoginForm-padding3-D1Ue1`,
	"padding4": `AdminLoginForm-padding4-eKsOE`,
	"padding5": `AdminLoginForm-padding5-qjgyj`,
	"padding6": `AdminLoginForm-padding6-WCOah`,
	"padding7": `AdminLoginForm-padding7-LdHzO`,
	"paddingTop1": `AdminLoginForm-paddingTop1-TbZGM`,
	"paddingTop2": `AdminLoginForm-paddingTop2-L_zmL`,
	"paddingTop3": `AdminLoginForm-paddingTop3-uGGks`,
	"paddingTop4": `AdminLoginForm-paddingTop4-u1ujn`,
	"paddingTop5": `AdminLoginForm-paddingTop5-B4ku8`,
	"paddingTop6": `AdminLoginForm-paddingTop6-JAzzV`,
	"paddingTop7": `AdminLoginForm-paddingTop7-u17kr`,
	"noPadding": `AdminLoginForm-noPadding-vwPF0`,
	"spaceMarginBottom0": `AdminLoginForm-spaceMarginBottom0-PvFBD`,
	"textBold": `AdminLoginForm-textBold-gylX9`,
	"textBolder": `AdminLoginForm-textBolder-p2lyt`,
	"textNormal": `AdminLoginForm-textNormal-dyYo3`,
	"textDarkBlue": `AdminLoginForm-textDarkBlue-w_yWE`,
	"textLightBlue": `AdminLoginForm-textLightBlue-I4mJt`,
	"textLightSandleGreen": `AdminLoginForm-textLightSandleGreen-ksOIB`,
	"textLightBrown": `AdminLoginForm-textLightBrown-a8ufN`,
	"textMediumMaroon": `AdminLoginForm-textMediumMaroon-Nq12N`,
	"textBrown": `AdminLoginForm-textBrown-HnTOj`,
	"textMaroon": `AdminLoginForm-textMaroon-Zy5ai`,
	"textDarkBrown": `AdminLoginForm-textDarkBrown-PKPB1`,
	"textMediumBrown": `AdminLoginForm-textMediumBrown-S0ZmG`,
	"textSkyBlue": `AdminLoginForm-textSkyBlue-wu94v`,
	"textGray": `AdminLoginForm-textGray-ZkAwj`,
	"errorMessage": `AdminLoginForm-errorMessage-w3bhr`,
	"userText": `AdminLoginForm-userText-JGPPb`,
	"panelHeader": `AdminLoginForm-panelHeader-LCVWK`,
	"exportSection": `AdminLoginForm-exportSection-P5dwC`,
	"exportSectionGridSub": `AdminLoginForm-exportSectionGridSub-z7Lf0`,
	"exportText": `AdminLoginForm-exportText-zMDXf`,
	"exportLinkImg": `AdminLoginForm-exportLinkImg-Eh2R4`,
	"exportImg": `AdminLoginForm-exportImg-NO3_N`,
	"linkBtn": `AdminLoginForm-linkBtn-B7UsF`,
	"table": `AdminLoginForm-table-dpwsJ`,
	"tableRow": `AdminLoginForm-tableRow-jYccS`,
	"tableCell": `AdminLoginForm-tableCell-JB3Y0`,
	"formGroup": `AdminLoginForm-formGroup-zV1G5`,
	"marginTop0": `AdminLoginForm-marginTop0-B0oSL`,
	"marginBottom20": `AdminLoginForm-marginBottom20-BmJLW`,
	"bannerImageBg": `AdminLoginForm-bannerImageBg-Y2ZS3`,
	"bannerDelete": `AdminLoginForm-bannerDelete-bPGpT`,
	"exportLink": `AdminLoginForm-exportLink-pLWrL`,
	"seachContent": `AdminLoginForm-seachContent-Hxuvm`,
	"marginBottom9": `AdminLoginForm-marginBottom9-XLx8v`,
	"spaceTop52": `AdminLoginForm-spaceTop52-lFpMo`,
	"profileViewInner": `AdminLoginForm-profileViewInner-GuLXP`,
	"profileViewMain": `AdminLoginForm-profileViewMain-yIRiz`,
	"profileViewlabel": `AdminLoginForm-profileViewlabel-lGl8E`,
	"profileViewMainContent": `AdminLoginForm-profileViewMainContent-YjYPL`,
	"reviewsFormStar": `AdminLoginForm-reviewsFormStar-pgKst`,
	"addLanguageText": `AdminLoginForm-addLanguageText-RTkE6`,
	"loginMainBg": `AdminLoginForm-loginMainBg-yMjYH`,
	"formInner": `AdminLoginForm-formInner-K8Qah`,
	"loginBg": `AdminLoginForm-loginBg-AcqCe`,
	"loginbtn": `AdminLoginForm-loginbtn-Mx3Ej`,
	"loginTitle": `AdminLoginForm-loginTitle-ufieP`,
	"loginTitleScetion": `AdminLoginForm-loginTitleScetion-sh6M8`,
	"arrowIconCss": `AdminLoginForm-arrowIconCss-eyxVu`,
	"topPadding": `AdminLoginForm-topPadding-D2gDM`,
	"twoPadding": `AdminLoginForm-twoPadding-VEOx7`,
	"bgColor": `AdminLoginForm-bgColor-ukpet`,
	"siteNameCss": `AdminLoginForm-siteNameCss-JRg0C`,
	"mobileWrap": `AdminLoginForm-mobileWrap-qjOrn`
};
module.exports = ___CSS_LOADER_EXPORT___;
